import './percentage.scss';
export default () => {

};
